<!--  -->
<template>
    <el-row>
                    <el-col :span="2">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input              
                        ref="RectangleChildInput1"
                        @keyup.enter.native="focusNextChild('RectangleChildInput2')"  v-model="param.X" @focus="handleChildFocus" @change="ChangData" placeholder="请输入参数X"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input              
                        ref="RectangleChildInput2"
                        @keyup.enter.native="focusNextChild('RectangleChildInput1')"  v-model="param.Y" @focus="handleChildFocus"  @change="ChangData" placeholder="请输入参数Y"></el-input>
                      </div>
                    </el-col>
  </el-row>
</template>
<script>
export default {
    name: "Rectangle",
    props: {
    myPost: {},
    formGlassW:{
      type:String,
    },
    formGlassH:{
      type:String,
    },
    
  },
  //  props: ["myPost"],
  data () {
    return {
      param:{        
        shapeName:"Rectangle",
          X:0,
          Y:0,
      }
   
    };
  },
  mounted(){
    this.param.X=this.formGlassW;
    this.param.Y=this.formGlassH;
    console.log("formGlassW=",this.formGlassW)
    console.log("formGlassH=",this.formGlassH)
  },
  watch: {
    formGlassW(newValue, oldValue){
      console.log(`formGlassW message  changed from ${oldValue} to ${newValue}`);
      
       if(newValue){
        console.log("this.parma.X=",this.param.X);
        console.log("this.parma=",this.param);
        this.param.X=newValue;
        this.param.Y=oldValue;
        //recieveMsg(shapeName,x,y,h,h1,h2,w,w1,w2)
        this.$emit("sedX",this.param);
      }
    },
    formGlassH(newValue, oldValue){
      console.log(`formGlassH message  changed from ${oldValue} to ${newValue}`);
       if(newValue){
        console.log("this.parma.Y=",this.param.Y);
        console.log("this.parma=",this.param);
        //recieveMsg(shapeName,x,y,h,h1,h2,w,w1,w2)
         this.param.Y=newValue;
        //  this.param.X=oldValue;
        this.$emit("sedX",this.param);
      }
    },
    // 监听message数据的变化
    myPost(newValue, oldValue) {
      console.log(`myPost message changed from ${oldValue} to ${newValue}`);
      if(newValue){
        console.log("this.parma.X=",this.param.X);
        console.log("this.parma=",this.param);
        //recieveMsg(shapeName,x,y,h,h1,h2,w,w1,w2)
        this.$emit("sedX",this.param);
      }
      // 在这里可以执行更多的逻辑
    },
  },
  methods:{
    ChangData(){
      console.log('The message is changed.',this.param);
      this.$emit("sedX",this.param)
    },
     // 处理焦点事件，选中文本并触发父组件监听
    handleChildFocus(event) {
   // console.log("handleChildFocus");
    setTimeout(() => {
        event.target.select();
      }, 0);
     // this.$emit('focused',event); // 通知父组件输入框被聚焦了。
    },
    focusNextChild(nextInputRef) {
      console.log("nextInputRef==",nextInputRef);
      this.$nextTick(() => {
        this.$refs[nextInputRef].focus(); // 使用Vue的$refs来聚焦到下一个输入框
      });
    },
  
  },
 
    
}
</script>